import * as Actions from '../../actions';

const initialState = { data: null };

const listProducerBusinessReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_PRODUCER_BUSINESS_LIST_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default listProducerBusinessReducer;
